import { ContactOverviewItem, ContactDetails } from '@futrli-sdk/predict';
import { API_PATHS, interpolatePathParams, REQUEST_METHODS, ROUTE_PARAMS } from '@futrli/shared-services';

import { QueryParams } from '../types';
import { makeRequestWithResponse } from './shared';

export const fetchCustomersAndSuppliers = async (
  workspaceId: string,
  organisationId: string,
  queryParams: QueryParams = {}
): Promise<ContactOverviewItem[]> => {
  const path = (() => {
    return interpolatePathParams(API_PATHS.CUSTOMERS_AND_SUPPLIERS, {
      [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
      [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId
    });
  })();
  return makeRequestWithResponse<ContactOverviewItem[]>({
    params: queryParams,
    url: path,
    method: REQUEST_METHODS.GET
  });
};

export const fetchCustomersAndSuppliersDetails = async (
  workspaceId: string,
  organisationId: string,
  contactId: string,
  queryParams: QueryParams = {}
): Promise<ContactDetails> => {
  const path = (() => {
    return interpolatePathParams(API_PATHS.CUSTOMERS_AND_SUPPLIERS_BY_ID, {
      [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
      [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
      [ROUTE_PARAMS.CONTACT_ID]: contactId
    });
  })();

  return makeRequestWithResponse<ContactDetails>({
    params: queryParams,
    url: path,
    method: REQUEST_METHODS.GET
  });
};
